import React, { useEffect } from "react";
import { initializeApp } from "firebase/app";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import { Navigate } from "react-router-dom";

import {
  getDatabase,
  ref,
  remove,
  onValue,
  onChildAdded,
  update,
} from "firebase/database";

import {
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithRedirect,
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import Reducer from "./Reducer";
import Contexto from "./Contexto";
import { useState, useReducer } from "react";
const firebaseConfig = {
  apiKey: "AIzaSyAJRxD6-3kU94I2JblDYDv-jpYmFC9zJeY",
  authDomain: "talleres-a-color.firebaseapp.com",
  databaseURL: "https://talleres-a-color-default-rtdb.firebaseio.com",
  projectId: "talleres-a-color",
  storageBucket: "talleres-a-color.appspot.com",
  messagingSenderId: "946136349850",
  appId: "1:946136349850:web:ed6e659e181ce0e9087323",
  measurementId: "G-R6WPM90N2S",
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getDatabase();
const examenes = ref(db, "/examenes");
const descuentis = ref(db, "/descuentos");
const seteoslocos = ref(db, "/seteos");

export default function UsarContexto(props) {
  let cantiad = 0;
  const location = useLocation();

  const { children } = props;
  const [estado, setEstado] = useState([]);
  const initialState = {
    tipo_plan: { mensual: false },
    productos: [],
    carrito: [],
    winter: [],
    cliente: null,
    usuario: null,
    seteos: null,
    isLoader: false,
    cursoscomprados: [],
    totales: [],
    verCurso: null,
    influencers: [],
    aDondeVoy: null,
    colorClub: [],
    mensajes: { mensaje: "" },
    baseCompleta: [],
    CC: false,
  };

  const [state, dispatch] = useReducer(Reducer, initialState);
  useEffect(() => {
    dispatch({ type: "ISLOAD", payload: true });
    traemeWinter();
    listameProductos();
    // dameEmails();
    //contarUsuarios();

    onValue(seteoslocos, (snap) => {
      dispatch({ type: "MIS_SETEOS", payload: snap.val() });
    });
    onValue(descuentis, (snap) => {
      dispatch({ type: "INFLUENCERS", payload: snap.val() });
    });
    onValue(examenes, (snap) => {
      dispatch({ type: "EXAMENES", payload: snap.val() });
    });
  }, []);

  const traemeWinter = () => {
    console.log("traemeWinter()");
    const summer = ref(db, "/summer");
    onValue(summer, (snap) => {
      const valores = snap.val();
      dispatch({ type: "DAME_WINTER", payload: valores });
    });
  };
  const traemeColorClub = () => {
    const summer = ref(db, "/cursos/color-club");
    onValue(summer, (snap) => {
      const valores = snap.val();
      dispatch({ type: "COLOR_CLUB", payload: valores });
    });
  };

  const listameProductos = async () => {
    const cursos = ref(db, "/cursosInfo/");
    onValue(cursos, (snap) => {
      const valores = snap.val();
      let claves = Object.keys(valores);
      for (let i = 0; i < claves.length; i++) {
        let clave = claves[i];
        dispatch({ type: "LISTAME_PRODUCTOS", payload: valores[clave] });
      }
      const params = new URLSearchParams(location.hash);
      let parametros = params.entries();
      let decode = atob(location.hash.substr(1));
      if (decode !== "" && location.pathname != "/ver") {
        autoCarga(decode);
      }
      dispatch({ type: "ISLOAD", payload: false });
    });
  };

  const googleProvider = new GoogleAuthProvider();
  const firebaseLogin = async () => {
    console.log("firebaseLogin");
    try {
      let credenciales = await signInWithRedirect(auth, googleProvider);
    } catch (error) {
      console.log("errror de login:", error);
      mandarMensajes(`error en Usuario o contraseña`);

      return false;
    }
    return true;
  };
  const loguearUsuario = () => {
    firebaseLogin();
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        let usuarioLogueado = {
          uid: user.uid,
          username: user.displayName,
          profile_picture: user.photoURL,
          email: user.email,
        };

        dispatch({ type: "USUARIO_LOGUEADO", payload: usuarioLogueado });
        buscarInfoCliente(usuarioLogueado.uid);
      }
    });
  }, []);

  const desconectarUsuario = () => {
    signOut(auth).then(() => {
      if (
        state.usuario.uid == "53OiHu2vSwSYhcVbzOT1vNp6k5t2" ||
        state.usuario.uid == "OAi2GYLt17dIUZWl1MiOXAb0fNk2"
      ) {
        mandarMensajes(`Chauuuu chechuuuuuuu ❤️`);
      } else {
        mandarMensajes(`Adios ${state.usuario.username}`);
      }

      dispatch({ type: "DESLOGUEAR_USUARIO", payload: null });
      dispatch({ type: "INFO_CLIENTE", payload: null });
      dispatch({ type: "USUARIO_LOGUEADO", payload: null });
      <Navigate to="/" />;
    });
  };

  const buscarInfoCliente = (uid) => {
    const refCliente = ref(db, "/usuarios/" + uid);
    onValue(refCliente, (snap) => {
      dispatch({ type: "INFO_CLIENTE", payload: snap.val() });
      if (snap.val().vencimientos) {
        controlarVencidos(snap.val().vencimientos);
      }
      mandarMensajes(`Holix ${snap.val().username}`);
      if (snap.val().compras) {
        console.log("tipoDePlan:", tipoDePlan(snap.val().compras));
      }
    });
  };

  const buscarDataCliente = (uid) => {
    const refCliente = ref(db, "/usuarios/" + uid);
    onValue(refCliente, (snap) => {
      dispatch({ type: "INFO_CLIENTE", payload: snap.val() });
    });
  };
  //////DAME EMAILS 2023 6/10/23
  const dameEmails = () => {
    const refUsuarios = ref(db, "/usuarios/"); // BUSCA EN FIREBASE
    // ACA RECORRE UNO X UNO
    onChildAdded(refUsuarios, (snap) => {
      const Usuario = snap.val(); // GUARDO EL RESULTADO EN USUARIO
      // VERIFICO SI TIENE EL NODO
      if (Usuario.vencimientos) {
        let vencidos = Usuario.vencimientos; //GUARDO LOS VENCIMIENTOS
        let hayUnVencido = false; // TESTIGO DE SI HAY
        // HAGO UN FOR DE UN BOJETO CON KEY
        for (let key in vencidos) {
          if (vencidos.hasOwnProperty(key)) {
            //MANDO el vencimiento a controlar
            let control = controlarVencimiento(key, vencidos[key].termina);
            // IMPORTANTE: condicion para dias restantes
            if (control.restantes <= 25) {
              hayUnVencido = true;
            }
          }
        }
        // ACA DEFINE TODO CONDICION========= >
        if (Usuario["color-club"]) {
          cantiad++;
          console.log(Usuario.email);
        }
      }
    });
  };

  let contarUsuarios = () => {
    const refUsuarios = ref(db, "/usuarios/"); // BUSCA EN FIREBASE
    // ACA RECORRE UNO X UNO
    onChildAdded(refUsuarios, (snap) => {
      const Usuario = snap.val(); // GUA
      if (Usuario["color-club"] == true) {
        console.log(Usuario.email);
      }
    });
  };

  const dameBaseDeUsuarios = () => {
    const refUsuarios = ref(db, "/usuarios/");
    onChildAdded(refUsuarios, (snap) => {
      const Usuario = snap.val();
      dispatch({ type: "PANEL_LOCO", payload: Usuario });
    });
  };

  const recuperoCarritoExistente = () => {
    let carritoGuardado = localStorage.getItem("carrito");
    carritoGuardado = JSON.parse(carritoGuardado);
    if (carritoGuardado) {
      dispatch({ type: "CARRITO_INICIAL", payload: carritoGuardado });
    }
  };
  const agregarCarrito = (payload) => {
    dispatch({ type: "AGREGAR_CARRITO", payload: payload });
    mandarMensajes(`Agregaste al carrito ${payload}`);
  };

  const eliminarCarrito = (payload) => {
    dispatch({ type: "ELIMINAR_CARRITO", payload: payload });
    mandarMensajes(`Eliminaste de carrito ${payload}`);
  };
  useEffect(() => {
    localStorage.setItem("carrito", JSON.stringify(state.carrito));
  }, [state.carrito]);
  const controlarVencidos = (cursos) => {
    let claves = Object.keys(cursos);
    for (let i = 0; i < claves.length; i++) {
      let clave = claves[i];
      dispatch({
        type: "CURSO_COMPRADO",
        payload: controlarVencimiento(clave, cursos[clave].termina),
      });

      if (clave == "color-club") {
        console.log("CONTROLO COLOR CLUB PA XD");
        dispatch({
          type: "CC",
          payload: controlarVencimiento(clave, cursos[clave].termina),
        });
      }
    }
  };

  let tipoDePlan = (compras) => {
    let claves = Object.keys(compras);
    let ultimaClave = claves[claves.length - 1];
    let ultimacompra = compras[ultimaClave];
    let desarmoFecha = ultimacompra.fecha.split("/");
    ultimacompra.vencimiento = desarmoFecha[0];
    if (ultimacompra.curso == "club-mensual") {
      ultimacompra.mensual = true;
      dispatch({ type: "TIPO_PLAN", payload: ultimacompra });
    } else {
      ultimacompra.mensual = false;
      dispatch({ type: "TIPO_PLAN", payload: ultimacompra });
    }
  };

  const controlarVencimiento = (quien, vencimiento) => {
    let hoy = new Date();
    let ahora = hoy.getTime();
    let quedan = vencimiento - ahora;
    let result = quedan / 1000 / 60 / 60 / 24;
    let leQuedan = Math.round(result);
    let vencido = true;
    if (leQuedan < 1) {
      vencido = false;
    }
    return { curso: quien, restantes: leQuedan, estado: vencido };
  };
  let borrarDatos = (referencia) => {
    let referenciaFinal = ref(db, referencia);
    remove(referenciaFinal);
    console.log("Borre datita jejeje");
  };
  let guardarDatos = (referencia, objeto) => {
    let referenciaFinal = ref(db, referencia);
    update(referenciaFinal, objeto);
  };
  let autoCarga = (dato) => {
    dispatch({ type: "AGREGAR_PACK", payload: dato });
  };
  const mandarMensajes = (payload) => {
    var fecha = new Date();
    dispatch({
      type: "NANDAR_MENSAJE",
      payload: { mensaje: payload, tiempo: fecha },
    });
  };
  const Griseado = (payload) => {
    dispatch({ type: "DONDE_VOY", payload: payload });
  };

  const buscarDataCurso = (payload) => {
    let refCurso = "";
    let escuela = payload.split("/");
    if (escuela[0] == "color-club") {
      refCurso = ref(db, "/cursos/color-club/8/" + escuela[2]);
    } else {
      refCurso = ref(db, "/cursos/" + payload);
    }

    onValue(refCurso, (snap) => {
      let listadoVideos = [];
      let claves = Object.keys(snap.val());
      for (let i = 0; i < claves.length; i++) {
        let clave = claves[i];
        listadoVideos.push(snap.val()[clave]);
      }
      dispatch({ type: "VER_CURSO", payload: listadoVideos });
      if (state.cliente.hasOwnProperty(`vistos_${payload}`)) {
        actualizaProgresosViejos(payload, listadoVideos);
      }
    });
  };

  const actualizaProgresosViejos = (curso, videosCurso) => {
    let vistosViejos = state.cliente["vistos_" + curso];
    let claves = Object.keys(vistosViejos); // claves = ["nombre", "color", "macho", "edad"]
    let data = {
      total: 0,
      ultimaVisita: Date.now(),
      videosVistos: [],
    };
    for (let i = 0; i < claves.length; i++) {
      let clave = claves[i];
      let url = vistosViejos[clave].url;
      let elemento = data.videosVistos.includes(url);
      if (!elemento) {
        data.videosVistos.push(vistosViejos[clave].url);
      }
    }
    let puntaje = videosCurso[0].puntaje;
    data.total = (100 / parseInt(puntaje)) * data.videosVistos.length;
    guardarDatos(`usuarios/${state.cliente.uid}/progreso/${curso}`, data);
    borrarDatos(`usuarios/${state.cliente.uid}/vistos_${curso}`);
  };
  const salvarProgreso = (curso, data) => {
    let armado = `usuarios/${state.cliente.uid}/progreso/`;
    let referenciaFinal = ref(db, armado);
    update(referenciaFinal, { [curso]: data });
  };
  const bajarCertificado = (curso) => {
    let urlx =
      "https://chart.googleapis.com/chart?cht=qr&chl=https%3A%2F%2Fcodearock.com%2Fcertificados%2F" +
      state.usuario.uid +
      "&chs=180x180&choe=UTF-8&chld=L|2%27%20rel=%27nofollow";
    var canvas = document.getElementById("micanvas");
    var ctx = canvas.getContext("2d");
    var img = new Image();
    img.src = urlx;
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      ctx.drawImage(img, 0, 0);
      let dataURL = canvas.toDataURL();
      let qr = dataURL;
      bajarCertificadou({
        curso: curso,
        uidx: state.usuario.uid,
        userNombre: state.cliente.username,
        mail: state.usuario.email,
        qr: dataURL,
      });
    };
  };
  const canjearCursos = (dato) => {
    let keyRegalo = dato.codigo;
    const cursoc = ref(db, `regalitos/${dato.codigo}`);
    try {
      onValue(cursoc, (snap) => {
        const regalin = snap.val();
        if (regalin.Hay && regalin.regaloKey != "Este código ya fue usado") {
          dameMiCurso({ pibe: state.usuario.uid, cursin: regalin.Cursos });
          quitarRegalo(keyRegalo);
        } else {
        }
      });
    } catch (err) {
      console.log(err);
    }
  };
  const quitarRegalo = (dato) => {
    var refeQuitar = ref(db, `regalitos/${dato}`);
    const tiempoTranscurrido = Date.now();
    const hoy = new Date(tiempoTranscurrido);
    const hora = hoy.toLocaleTimeString();
    const fecha = hoy.toDateString();
    const fechin = `${fecha} - ${hora}`;
    try {
      update(refeQuitar, {
        Hay: false,
        canjeadoPor: state.usuario.uid,
        canjeadoEl: fechin,
        regaloKey: "Este código ya fue usado",
      });
    } catch (err) {
      console.log(err);
    }
  };

  const dameMiCurso = (dato) => {
    console.log("dameMiCurso()", dato);
    let refUsuario = ref(db, `usuarios/${state.usuario.uid}`);
    let refUsuarioVen = ref(db, `usuarios/${state.usuario.uid}/vencimientos/`);
    let refCompras = ref(db, `usuarios/${state.usuario.uid}/compras/`);

    let cuenta = 1000 * 60 * 60 * 24 * 730;
    let hoy = new Date();
    let ahora = hoy.getTime();
    let anio = ahora + cuenta;
    try {
      for (const prop in dato.cursin) {
        update(refUsuario, {
          [dato.cursin[prop]]: true,
        });
        update(refUsuarioVen, {
          [dato.cursin[prop]]: { termina: anio },
        });
        update(refCompras, {
          [cuenta]: {
            curso: dato.cursin[prop],
            fecha: new Date().toLocaleDateString(),
            precio: "desde la web ndeah",
          },
        });
      }
    } catch (err) {
      console.log("dameMiCurso ", err);
    }
  };
  const bajarCertificadou = (dato) => {
    const { curso, userNombre, mail, qr, uidx } = dato;
    const cursoc = ref(db, `/certificados/${curso}`);
    onValue(cursoc, (snap) => {
      const cer = snap.val();
      var doc = new jsPDF("landscape", "mm");
      doc.addImage(cer, "PNG", 0, 0, 297, 210);
      doc.addImage(qr, "PNG", 20, 130, 50, 50);
      doc.setFontSize(40);
      doc.setFont("helvetica");
      doc.setTextColor(79, 79, 79);
      doc.text(25, 80, userNombre);
      doc.setFontSize(15);
      doc.text(25, 88, mail);
      doc.text(25, 193, _hoyFecha());
      doc.setFontSize(10);
      doc.text(25, 204, uidx);
      const nombre = "DevRockCertifica-" + curso + ".pdf";
      doc.save(nombre);
    });
  };
  const _hoyFecha = () => {
    function addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    }
    var hoy = new Date();
    var dd = hoy.getDate();
    var mm = hoy.getMonth() + 1;
    var yyyy = hoy.getFullYear();
    dd = addZero(dd);
    mm = addZero(mm);
    return dd + "/" + mm + "/" + yyyy;
  };
  const cambiaPrecio = (curso, precio) => {
    dispatch({
      type: "CAMBIA_PRECIO",
      payload: { curso: curso, precio: precio },
    });
  };

  let crearUsuarioConEmail = (email, password) => {
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        if (user) {
          let usuarioLogueado = {
            uid: user.uid,
            username: user.displayName,
            profile_picture: user.photoURL,
            email: user.email,
          };
          dispatch({ type: "USUARIO_LOGUEADO", payload: usuarioLogueado });
        }
      })
      .catch((error) => {
        const errorMessage = error.message;
        if (errorMessage == "Firebase: Error (auth/email-already-in-use).") {
          mandarMensajes(`Tu email ya tiene una cuenta.`);
        }
      });
  };
  let loginUsuarioConEmail = (email, password) => {
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        if (user) {
          let usuarioLogueado = {
            uid: user.uid,
            username: user.displayName,
            profile_picture: user.photoURL,
            email: user.email,
          };
          dispatch({ type: "USUARIO_LOGUEADO", payload: usuarioLogueado });
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log("----->", error);
        if (error.message == "Firebase: Error (auth/wrong-password).") {
          mandarMensajes(`Contraseña incorrecta.`);
        }
        if (error.message == "Firebase: Error (auth/user-not-found).") {
          mandarMensajes(`Usuario incorrecto.`);
        }
        if (error.message == "Firebase: Error (auth/invalid-email).") {
          mandarMensajes(`Email incorrecto.`);
        }
      });
  };
  let resetPassword = (email) => {
    const auth = getAuth();
    sendPasswordResetEmail(auth, email)
      .then(() => {
        mandarMensajes(`Checkea tu email.`);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
      });
  };
  let bajarPreset = (dato, dato2) => {
    const dbRef = ref(db, "cursos/" + dato);

    onValue(dbRef, (snap) => {
      const preset = snap.val();
      if (dato2 !== "ver") {
        console.log("bajamos:", dato2);
        window.open(preset.preset, "Download");
      } else {
        console.log("bajamos:", dato2);
        window.open(preset.instructivo, "Download");
      }
    });
  };
  let DaleElCurso = (dato) => {
    console.log("DaleElCurso---()", dato);
    let refUsuario = ref(db, `usuarios/${dato.uid}`);
    let refUsuarioVen = ref(db, `usuarios/${dato.uid}/vencimientos/`);
    let refCompras = ref(db, `usuarios/${dato.uid}/compras/`);

    let cuenta = 1000 * 60 * 60 * 24 * 730;
    let hoy = new Date();
    let ahora = hoy.getTime();
    let anio = ahora + cuenta;
    try {
      for (const prop in dato.cursin) {
        update(refUsuario, {
          [dato.cursin[prop]]: true,
        });
        update(refUsuarioVen, {
          [dato.cursin[prop]]: { termina: anio },
        });
        update(refCompras, {
          [cuenta]: {
            curso: dato.cursin[prop],
            fecha: new Date().toLocaleDateString(),
            precio: "desde la web ndeah o panel",
          },
        });
      }
    } catch (err) {
      console.log("dameMiCurso ", err);
    }
  };
  let sorteados = (dato) => {
    guardarDatos("/sorteadites", dato);
    mandarMensajes(`Ya estás participando del sorteo.`);
  };
  return (
    <Contexto.Provider
      value={{
        verCurso: state.verCurso,
        productos: state.productos,
        carrito: state.carrito,
        seteos: state.seteos,
        winter: state.winter,
        usuario: state.usuario,
        cliente: state.cliente,
        influencers: state.influencers,
        cursoscomprados: state.cursoscomprados,
        examenes: state.examenes,
        isLoader: state.isLoader,
        mensajes: state.mensajes,
        aDondeVoy: state.aDondeVoy,
        colorClub: state.colorClub,
        baseCompleta: state.baseCompleta,
        CC: state.CC,
        tipo_plan: state.tipo_plan,
        sorteados,
        dameMiCurso,
        bajarPreset,
        cambiaPrecio,
        bajarCertificado,
        salvarProgreso,
        buscarDataCurso,
        autoCarga,
        Griseado,
        mandarMensajes,
        listameProductos,
        guardarDatos,
        agregarCarrito,
        eliminarCarrito,
        loguearUsuario,
        desconectarUsuario,
        buscarInfoCliente,
        canjearCursos,
        buscarDataCliente,
        crearUsuarioConEmail,
        loginUsuarioConEmail,
        resetPassword,
        traemeColorClub,
        dameBaseDeUsuarios,
        DaleElCurso,
      }}
    >
      {children}
      <canvas
        height="180px"
        width="180px"
        id="micanvas"
        style={{ display: "none" }}
      ></canvas>
    </Contexto.Provider>
  );
}
